<style scoped lang="scss">
	.active{
		background: #1973bf;
	}
	.container {
		width: 100%;
		height: 100%;
		overflow: hidden;
		.header {
			height: 60px;
			line-height: 60px;
			background: #1d8ce0;
			position: relative;
			.userinfo-inner__avatar {
				width: 40px;
				height: 40px;
				border-radius: 50%;
				overflow: hidden;
			}
			.common-use__title{
				opacity: .7;
			}
			.common-use__item{
				padding: 0 20px 0 15px;
				transition: background .2s;
				position: relative;
				&:hover{
					background: #1780d0;
				}
				i { position: absolute; top: 10px; right: 5px; font-style: normal; font-size: 12px; background: #F56C6C; color: white; width: 20px; height: 20px; line-height: 21px; text-align: center; border-radius: 50%; }
			}
			.userinfo-item{
				height: 60px;
				&:hover {
					background: #1780d0;
				}
				.userinfo-item__badge{
					height: 20px;
					line-height: 20px;
				}
			}
			.logo { height: 60px; line-height: 41px; }
			.expired { position: absolute; line-height: normal; bottom: 6px; left: 10px; letter-spacing: 0.5px; 
				span, i { float: left; height: 20px; line-height: 22px; font-size: 12px; }
				span { color: rgba(255, 255, 255, 0.6); }
				i { font-style: normal; background: #F56C6C; color: white; padding: 0 5px; border-radius: 3px; transform: scale(0.84); }
			}
		}
		.main {
			overflow: hidden;
			align-items: stretch;
			.menu {
				position: relative;
				padding-bottom: 30px;
				&:hover .menu-toggle{
					margin-right: 1px;
					opacity: 1;
				}
				.menu-info{
					overflow-y: auto;
					overflow-x: hidden;
				}
				.menu-toggle{
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					right: -20px;
					width: 20px;
					height: 30px;
					text-align: center;
					line-height: 29px;
					border: 1px solid #e6e6e6;
					border-left: none;
					border-top-right-radius: 3px;
					border-bottom-right-radius: 3px;
					background: #fff;
					z-index: 2;
					margin-right: 20px;
					opacity: 0;
					transition: all .3s;
				}
			}
			.content-container {
				overflow: auto;
				height: 100%;
				.breadcrumb-container {
					padding: 20px;
					.title {
						color: #475669;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
					height: 100%;
					&.is-fullscreen {
						background: transparent;
					}
				}
			}
		}
		.userinfo-inner {
			padding: 0 10px;
			&:hover {
				background: #1780d0;
			}
		}
	}
	.message-container {
		display: flex;
		flex-direction: column;
		max-height: 610px;
		overflow: hidden;
		.message-box {
			// max-height: 610px;
			flex: 1;
			display: flex;
			flex-direction: column;
			overflow: hidden;
			&-content {
				flex: 1;
				overflow-y: auto;
				overflow-x: hidden;
			}
			.message-item {
				display: flex;
				padding: 20px 0;
				margin: 0 24px 0 16px;
				align-items: center;
				// border-bottom: 1px solid #DDDDDD;
				cursor: pointer;
				position: relative;
			}
			/*边框*/
			.message-item:after {
				position: absolute;
				z-index: 1;
				left: 0;
				right: 0;
				bottom: 0;
				height: 0;
				content: '';
				transform: scaleY(.5);
				border-bottom: 1px solid #ddd;
			}
			.red-dot {
				display: inline-block;
				width: 10px;
				height: 10px;
				background: #FF4848;
				border-radius: 50%;
				position: absolute;
				left: 0px;
			}
			.type-icon {
				width: 44px;
				height: 44px;
				margin-left: 17px;
				margin-right: 21px;
			}
			.message-content {
				flex: 1;
			}
			.message-type {
				margin-bottom: 4px;
				display: flex;
				justify-content: space-between;
				&-title {
					font-size: 16px;
					font-weight: 500;
					color: #333333;
				}
			}
			.message-body{
				display: flex;
				max-width: 268px;
				.message-tips{
					flex: 1;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.message-status{
					margin-left: 10px;
				}
			}
			.message-time, .message-tips {
				font-size: 14px;
				font-weight: 500;
				color: #666666;
			}
		}
		.footer-container {
			padding: 10px 0;
			// height: 168px;
			color: #333;
			margin: 0 24px 0 16px;
			&-content {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
		}
	}
	.no-message-data {
		text-align: center;
		padding: 20px 0;
	}
	.userinfo-item__message {
		padding: 0 20px;
	}
	.icp-footer {
		position: fixed;
		width: 213px;
		left: 0;
		bottom: 0;
		height: 28px;
		line-height: 28px;
		text-align: center;
		background: #f5f5f5;
		border-top: 1px solid #e8e8e8;
		border-right: 1px solid #e8e8e8;
		flex-shrink: 0;
		a {
			font-size: 12px;
			color: #999;
			text-decoration: none;
			&:hover {
				color: #1d8ce0;
				text-decoration: underline;
			}
		}
	}
</style>
<style lang="scss">
	.page-home {
		.el-menu { min-width: 212px; }
		.el-menu--collapse { min-width: auto !important; }
		.el-submenu { border-bottom: 1px solid #eee;
			.el-submenu__title {
				i.fa { color: #409EFF !important; margin-right: 4px; }
			}
			&.is-opened {
				.el-submenu__title { background: #E0EDF6 !important; color: #409EFF !important; font-weight: bold;
					i { color: #409EFF !important; }
				}
			}
		}
		.el-menu-item {
			&.menu-item-index { background: #FEE2CC !important;
				i.fa { margin-right: 4px; }
			}
		}
	}
	.dialog-billing-edit {
        .el-dialog { position: relative; height: 95%; }
        .el-dialog__header { position: relative; z-index: 10; padding: 0;
            .el-dialog__headerbtn { top: 21px; right: 24px; }
        }
        .el-dialog__body { padding: 0 !important; position: absolute; top: 0; left: 0; right: 0; bottom: 0; }
        iframe { display: block; width: 100%; height: 100%; }
    }
	.message-popper {
		padding: 0 !important;
		border-radius: 20px !important;
		border: 1px solid #F5F5F5 !important;
		box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1) !important;
	}
</style>
<template>
	<div class="container flex-column-start page-home">
		<!-- 头部start -->
		<el-row class="header text-white" v-if="!$route.query.nonav && !isFullscreen">
			<div class="expired">
				<span>店铺有效期至：{{expired_date}}</span>
				<i v-if="expired_day <= 15">{{expired_day > 0 ? expired_day + '天后过期' : '已过期'}}</i>
			</div>
			<el-col :span="4" class="logo PL-10">
				<span class="text-22">{{ sysShopName || '广州白云店'}}</span>
			</el-col>
			<el-col :span="16">
				<dl class="flex-row-start">
					<dt class="common-use__title MR-10" style="height: 60px; overflow: hidden;">常用功能</dt>
					<dd
						style="height: 60px; overflow: hidden;"
						class="common-use__item text-16 pointer"
						v-for="(item, index) in commonModules"
						v-if="item.show"
						@click="linkTo(item)"
						:key="index"
						:class="{'active': $route.path === item.path}">
						<span class="fa fa-fw MR-5" :class="[item.icon]"></span>
						{{item.name}}
					</dd>
					<dd
						v-if="privilegeObject && privilegeObject[34]"
						style="height: 60px; overflow: hidden;"
						class="common-use__item text-16 pointer"
						@click="$router.push({ path: '/buying/index' })">
						<span class="fa fa-fw MR-5 fa-shopping-basket"></span>
						报价
						<i v-if="peekCount">{{peekCount}}</i>
					</dd>
					<dd
						v-if="privilegeObject && privilegeObject[32]"
						style="height: 60px; overflow: hidden;"
						class="common-use__item text-16 pointer"
						@click="openQxb('main_tab=11&opc_vin=', '查EPC')">
						<span class="fa fa-fw MR-5 fa-search"></span>
						查EPC
					</dd>
					<dd
						v-if="privilegeObject && privilegeObject[33]"
						style="height: 60px; overflow: hidden;"
						class="common-use__item text-16 pointer"
						@click="openQxb('main_tab=19&oem=', '查OE')">
						<span class="fa fa-fw MR-5 fa-search"></span>
						查OE
					</dd>
				</dl>
			</el-col>
			<el-col :span="4" class="userinfo text-right PR-20 flex-row-end">
				<div class="text-16 pointer MR-20 flex-column-center userinfo-item">
					<el-popover
						placement="bottom-end"
						width="400"
						popper-class="message-popper"
						:offset="30"
						@show="openMessageList"
						trigger="click">
						<div class="message-container">
							<div class="message-box">
								<div class="message-box-content" id="message-box">
									<div class="message-item" v-for="(item, index) in orderMessageList" :key="index" @click="handleToOrderDetail(item)">
										<i class="red-dot" v-if="item.is_read == 0"></i>
										<img src="~@/assets/images/message_type_icon.png" class="type-icon" v-if="item.notify_type == '0'">
										<img src="~@/assets/images/message_type_refund.png"  class="type-icon" v-if="item.notify_type == '1'">
										<img src="~@/assets/images/message_type_approval.png" class="type-icon" v-if="item.notify_type == '2'">
										<img src="~@/assets/images/message_type_goods.png" class="type-icon" v-if="item.notify_type == '3'">
										<div class="message-content">
											<div class="message-type">
												<span class="message-type-title">{{item.title}}</span>
												<span class="message-time">{{filterTime(item.created_at)}}</span>
											</div>
											<div class="message-body">
												<span class="message-tips text_overflow">{{item.content}}</span>
												<span  
													v-if="orderStatusMap[item.order_status]" 
													:style="{color: orderStatusMap[item.order_status].color}"
													class="message-status" 
												>
													{{ orderStatusMap[item.order_status].name }}
												</span>
											</div>
										</div>
									</div>
									<p v-if="orderMessageList.length === 0" class="no-message-data">暂无消息哦</p>
								</div>
							</div>
							<div class="footer-container">
								<div class="footer-container-content">
									<span class="sum">未读{{unread_count || 0}}条</span>
									<div class="btn-box">
										<el-button size="small" type="primary" plain @click="handleSetRead('all')" :disabled="orderMessageList.length === 0">全部标记已读</el-button>
										<el-button size="small" type="primary" plain @click="handleClearMessage" :disabled="orderMessageList.length === 0">清空记录</el-button>
									</div>
								</div>
							</div>
						</div>
						<div slot="reference" class="userinfo-item__message">
							<el-badge :value="unread_count > 99 ? '99+' : unread_count" class="userinfo-item__badge" v-if="unread_count > 0">
								<i class="iconfont iconxiaoxizhongxin" style="font-size:20px"></i>
							</el-badge>
							<i class="iconfont iconxiaoxizhongxin" style="font-size:20px" v-else></i>
						</div>
					</el-popover>
					<audio src="" style="opacity: 0;" ref="audio" muted preload></audio>
				</div>
				<el-dropdown>
					<div class="el-dropdown-link userinfo-inner text-white pointer">
						<img :src="this.sysUserAvatar" v-if="false" />{{userInfo.username || userInfo.shop_name}}
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="openNotice(1)">版本信息</el-dropdown-item>
						<el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-row>
		<!-- 头部end -->
		<main class="main flex-h__1 flex-row-start">
			<!-- 导航菜单start -->
			<div class="menu flex-column-start" v-if="!$route.query.nonav && !isFullscreen">
				<el-menu
					:default-active="$route.path"
					router
					:collapse="collapsed"
					:collapse-transition="false"
					:unique-opened="true"
					class="flex-h__1 menu-info">
					<template
						v-for="(item,index) in routes"
						v-if="!item.hidden">
						<el-submenu
							:index="index+''"
							v-if="!item.leaf && item.has"
							:key="index+''">
							<template slot="title">
								<i :class="item.iconCls"></i>
								<span slot="title">{{item.name}}</span>
							</template>
							<el-menu-item
								v-for="child in item.children"
								:index="child.path"
								:key="child.path"
								v-if="!child.hidden && child.has"
							>
								{{child.name}}
							</el-menu-item>
						</el-submenu>
						<el-menu-item
							v-if="item.leaf && item.children.length > 0"
							:index="item.children[0].path"
							:key="item.children[0].path"
							:class="{ 'menu-item-index': item.path == '/index' }"
						>
							<i :class="item.iconCls" :style="`color: ${item.path == '/index' ? '#ff8200' : ''};`"></i>
							<span slot="title" :style="`color: ${item.path == '/index' ? '#ff8200' : ''};`">
								{{item.children[0].name}}
							</span>
						</el-menu-item>
					</template>
				</el-menu>
				<div class="menu-toggle pointer" @click="collapse">
					<span class="fa" :class="[collapsed ? 'fa-angle-double-right': 'fa-angle-double-left']"></span>
				</div>
			</div>

			<!-- 导航菜单end -->
			<!-- 主体内容start -->
			<section class="content-container flex-w__1 flex-column-start" :style="`overflow: ${$route.path == '/stock/list' || isFullscreen ? 'hidden' : 'auto'}`" v-if="contentBol">
				<div class="content-wrapper flex-h__1 flex-column-start" :class="{ 'MT-20': !isFullscreen && !noContentMargin, 'is-fullscreen': isFullscreen }">
					<transition name="el-fade-in-linear" mode="out-in">
						<router-view v-if="!$route.meta.keepAlive" class="flex-h__1"></router-view>
					</transition>
					<transition name="el-fade-in-linear" mode="out-in">
						<keep-alive>
							<router-view v-if="$route.meta.keepAlive" class="flex-h__1"></router-view>
						</keep-alive>
					</transition>
				</div>
			</section>
			<!-- 主体内容end -->
		</main>
		<!-- 备案号footer start -->
		<footer class="icp-footer" v-if="showIcpBox && !isFullscreen">
			<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" rel="noopener noreferrer">ICP备案号：粤ICP备09172001号-5</a>
		</footer>
		<!-- 备案号footer end -->
	</div>
</template>

<script>
	import Vue from 'vue'
	import userAvatar from '@/assets/images/xiaoheshang.jpg'
	import { getqxbURL } from '@/assets/js/ulits.js'
	import { config } from '@config/network.js'
	import { myTime } from '@/assets/js/ulits.js'
    import AudioScope from '@/assets/js/audio/scope.js'
	import axios from 'axios'
	let ccjTopTimer = null
	let ccjTopListTimer = null
	let exportTimer = null

	export default {
		data() {
			return {
				userInfo: {},
				// 导航栏是否折叠
				collapsed: false,
				sysUserName: '',
				sysShopName: '',
				sysUserAvatar: userAvatar,
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				commonModules: [],
				routes: [],
				privilegeObject: null,
				contentBol: false,
				peekCount: 0,
				expired_date: '',
				expired_day: 0,
				exportProps: {
					disabled: false,
					process: 0,
					taskId: ''
				},
				orderMessageList: [],
				unread_count: 0,
				loading: false,
				orderStatusMap: {
					'待发货': { name: '待发货', color: '#FF0000' }, // 红色
					'待收货': { name: '待收货', color: '#FFA500' }, // 黄色
					'已完成': { name: '已完成', color: '#008000' }, // 绿色
					'退货退款中': { name: '退货退款中', color: '#FFA500' }, // 橙色
					'退款完成': { name: '退款完成', color: 'blue' }, // 蓝色
					'退款关闭': { name: '退款关闭', color: '#808080' }, // 灰色
					'已关闭': { name: '已关闭', color: '#808080' }, // 灰色
				}
			}
		},
		created () {
			this.getPrivilegeList()
			this.getAllAreaList()

			this.userInfo = JSON.parse(localStorage.getItem('userInfo'));

			this.getQxbToken()
			this.openNotice()

			this.getMerchantPeek()
			this.getMerchantCount()
			if (ccjTopTimer) {
                clearInterval(ccjTopTimer)
			}
			if (ccjTopListTimer) {
                clearInterval(ccjTopListTimer)
			}
			if (exportTimer) {
                clearInterval(exportTimer)
			}
			ccjTopTimer = setInterval(() => {
				this.getMerchantPeek()
			}, 5000);
			ccjTopListTimer = setInterval(() => {
				this.getMerchantCount()
			}, 30 * 1000);
			const exportProps = localStorage.getItem('product-export-props-' + this.userInfo.name) ? JSON.parse(localStorage.getItem('product-export-props-' + this.userInfo.name)) : null
			if (exportProps && exportProps.taskId && this.userInfo.uid) {
				this.exportProps = exportProps
				exportTimer = setInterval(() => {
					this.exportProcess()
				}, 1000);
			}
		},
		computed:{
            getStaticUrl(){
				return location.origin.indexOf('localhost') !== -1 ? '/static' : '/warehouse_apply_front/static'
			},
			showIcpBox(){
				return window.location.origin.indexOf('qp11.cn') !== -1 && !this.collapsed
			},
			isFullscreen() {
				return this.$route.meta && this.$route.meta.fullscreen
			},
			noContentMargin() {
				return this.$route.meta && this.$route.meta.noMargin
			}
		},
		methods: {
			openMessageList() {
				this.$messageOrder.page = 1
				this.$messageOrder._getOrderList({page: this.$messageOrder.page, limit: 50, reload: true})
			},
			exportProcess() {
				this.$ajax("https://api-ycj.nanxinwang.com/export/process", {
					sessionId: this.userInfo.session_id,
					id: this.exportProps.taskId
				}, { method: 'GET', load: false }).then(res => {
					this.exportProps.process = res.data.process
					if (this.exportProps.process == 100) {
						clearInterval(exportTimer)
						this.exportDownload()
					}
					localStorage.setItem('product-export-props-' + this.userInfo.name, JSON.stringify(this.exportProps))
					if(res.status != 0 || !this.userInfo.uid || (!res.data.process && res.data.process !== 0)) {
						clearInterval(exportTimer)
						localStorage.removeItem('product-export-props-' + this.userInfo.name)
					}
				}).catch(res => {
						clearInterval(exportTimer)
						localStorage.removeItem('product-export-props-' + this.userInfo.name)
				});
			},
			exportDownload() {
				if(!this.exportProps.taskId) {
						this.$message.warning('任务ID不能为空')
						return
				}
				axios({
					method: 'GET',
					url: `https://api-ycj.nanxinwang.com/export/download?sessionId=${this.userInfo.session_id}&id=${this.exportProps.taskId}`,
					responseType: 'arraybuffer'
				})
				.then(res => {
					this.exportProps.disabled = false
					this.exportProps.taskId = ''
					const data = res.data
					const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
					const link = document.createElement('a')
					link.style.display = 'none'
					link.href = url
					link.setAttribute('download', `导出产品_${Date.parse(new Date()) / 1000}.zip`)
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
				})
			},
			getMerchantCount() {
				const userInfo = JSON.parse(localStorage.getItem('userInfo'))
				let params = localStorage.getItem('ccj-params-' + userInfo.name) ? JSON.parse(localStorage.getItem('ccj-params-' + userInfo.name)) : { accountId: '', citys: '', brands: '', page: '1', rows: '20', read: '0', }
				params.read = '0'
				const token = localStorage.getItem('ccj-token-' + userInfo.name) || ''
				if (!token) return
				this.$ajax(config.CCJ_API + 'require/list?quote=0&isPaging=true', params, { method: 'GET', load: false }).then(res => {
					if (res.status == -1) {
						localStorage.removeItem('ccj-token-' + userInfo.name)
						return	
					}
					localStorage.setItem('buying-ccj-total-' + userInfo.name, res.data.page.total)
				})
			},
			getMerchantPeek() {
				const userInfo = JSON.parse(localStorage.getItem('userInfo'))
				const current = localStorage.getItem('buying-ccj-current-' + userInfo.name) ? Number(localStorage.getItem('buying-ccj-current-' + userInfo.name)) : 0
				const total = localStorage.getItem('buying-ccj-total-' + userInfo.name) ? Number(localStorage.getItem('buying-ccj-total-' + userInfo.name)) : 0
				const token = localStorage.getItem('ccj-token-' + userInfo.name) || ''
				if (!token) {
					this.peekCount = 0
					return
				}
				let notice = '1'
				if (localStorage.getItem('ccj-notice-' + userInfo.name)) {
					notice = localStorage.getItem('ccj-notice-' + userInfo.name)
				}
				this.peekCount = notice == 1 ? total - current : 0
			},
			getPrivilegeList() {
				this.$ajax('/Admin/ShopSettings/getGraphicsChoosePermissionList').then(res => {
					let resObj = Object.fromEntries(res.data.list.map(item => [item.type, item]))
					localStorage.setItem('sepc-privilege', JSON.stringify(resObj))
				})
				this.$ajax('Admin/UserChild/getPrivilegeList', { type: 2 }).then(res => {
					let third_platform_allow = res.data.third_platform_allow.reduce((pre, next) =>{
						if(!pre[next.privilege_id]){
							pre[next.privilege_id] = [next.plat_id]
						}else{
							pre[next.privilege_id].push(next.plat_id)
						}
						return pre
					}, {})
					localStorage.setItem('third-platform-allow', JSON.stringify(third_platform_allow))
					localStorage.setItem('privilege-list', JSON.stringify(res.data.list))
					localStorage.setItem('privilege-object', JSON.stringify(res.data.privilege))

					this.privilegeObject = JSON.parse(localStorage.getItem('privilege-object'))

					if (res.data.shop) {
						this.expired_date = this.myTime(Number(res.data.shop.expiry_dateline) * 1000)
						if (res.data.shop.expiry_dateline != 0) {
							this.expired_day = Math.ceil((Number(res.data.shop.expiry_dateline) - Number(res.data.shop.time_server)) / (60 * 60 * 24))
						}
					}

					if (!this.privilegeObject) {
						localStorage.removeItem('userInfo');
						this.$router.push('/login');
						return
					}

					this.commonModules = [
						{ index: 0, name: '查产品', icon: 'fa-search', path: '/stock/list', show: this.privilegeObject[9] },
						{ index: 1, name: '开单', icon: 'fa-rmb', path: '/sales/order/orderList', show: this.privilegeObject[11] },
						{ index: 2, name: '退货', icon: 'fa-undo', path: '/sales/return/list', show: this.privilegeObject[14] },
						{ index: 3, name: '进货', icon: 'fa-sign-in', path: '/sales/purchase/list', show: this.privilegeObject[16] },
					]

					const privilegeList = JSON.parse(localStorage.getItem('privilege-list'))
					let routes = JSON.parse(JSON.stringify(this.$router.options.routes))
					privilegeList.forEach((item, itemIndex) => {
						let first = routes.find(obj => obj.id == item.id)
						if (first) {
							first.has = item.has
							first.name = item.name
							first.sort = itemIndex + 1
							if(first.id == 204){
								first.has = res.data.data_borad == 1 ? 1 : item.has
							}
						}
						item.child.forEach((data, dataIndex) => {
							if (first) {
								let second = first.children.find(obj => obj.id == data.id)
								if (second) {
									// 产品定价特殊处理
									if (second.id === 128) {
										second.has = data.has && this.privilegeObject[183] ? 1 : 0;
									} else if([205, 227].includes(second.id)){
                                        second.has = res.data.data_borad == 1 ? 1 : data.has;
									}else {
										second.has = data.has;
									}
									second.name = data.name
									second.sort = dataIndex + 1
								}
							}
						})
					})
					let hasBol = true
					routes.forEach(item => {
						if (item.children) {
							item.children.forEach(data => {
								if (data.path == this.$route.path) {
									if (!data.has) {
										hasBol = false
										this.$router.replace('/index')
										setTimeout(() => {
											this.contentBol = true
										}, 500)
									}
								}
							})
						} else {
							item.sort = 0
						}
					})
					routes.sort((a, b) => a.sort - b.sort)
					routes.forEach(item => {
						if (item.children) {
							item.children.sort((a, b) => a.sort - b.sort)
						}
					})
					this.routes = routes
					if (hasBol) {
						this.contentBol = true
					}
				})
			},
			linkTo(item) {
				this.$router.push({ path: item.path })
			},
			openQxb(extend, title, show_left) {
				const url = this.getqxbURL(extend, show_left)
				import('../dialogs/qxbDialog').then(comp => {
                    this.$openSilde(comp, {
                        dialog_title: title,
                        qxb_url: url
                    }).then(vm => {
                        vm.$once('close', val => {
                            this.getQxbToken()
                        })
                    })
                })
			},
			getQxbToken() {
				const userInfo = JSON.parse(localStorage.getItem('userInfo'))
                this.$ajax(config.QXB_API + '?version=5.10.2&action=OPEN.Member.Login', {
					appid: config.APPID,
                    mobile: userInfo.name,
                    platform_unique_identify: userInfo.uid
                }).then(res => {
                    localStorage.setItem('qxb_token', res.data.token)
                })
            },
			// 退出登录
			logout() {
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
					this.$ajax("Admin/Users/logout", {}, { method: "POST" } ).then(res => {
						if (res.status === 200) {
							// this.$message.success(res.data.message)
							const userInfo = JSON.parse(localStorage.getItem('userInfo'))
							localStorage.removeItem(`product-export-props-${userInfo.name}`)
							localStorage.removeItem('userInfo');
							this.$router.push('/login');
						} else {
							this.$message.error(res.data.message)
						}
					})
				}).catch(() => {

				});
			},
			// 折叠导航栏
			collapse(){
				this.collapsed = !this.collapsed;
			},
			showMenu(i,status){
				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
			},
			/**
			 * 校验公告是否展示
			 */
			async noticeHanlder() {
				let version = await this.$storage.getItem('version')
				// 如果当前本地没有缓存或者本地的版本和当前项目的版本不对应
				console.log(version, config)
				if (!version || version !== config.VERSION) {
					this.$storage.setItem('version', config.VERSION)
					if (config.SHOW_NOTICE) {
						// this.openNotice()
					}
				}
			},
			/**
			 * 打开系统公告通知
			 */
			openNotice(type = 0) {
				const _this = this
				const url = `https://img2.nanxinwang.com/static/warehouse_apply_notify/notify.html?v=${Date.now()}`
				this.$nextTick(() => {
					document.domain = 'nanxinwang.com';
					let iframe = document.createElement('iframe');
					iframe.src = url;
					iframe.style.display = 'none';
					document.body.append(iframe);
					iframe.onload = function() {
						let win = iframe.contentWindow;
						const updateTime = win.updateTime
						const userInfo = JSON.parse(localStorage.getItem('userInfo'))
						const notifyTime = localStorage.getItem('notify_time_' + userInfo.name) || ''
						const notify = {
							update: updateTime,
							url
						}
						if (notifyTime != notify.update || type == 1) {
							localStorage.setItem('notify_time_' + userInfo.name, notify.update)
							import('./SystemNotice.vue').then(comp => {
								_this.$openSilde(comp, {
									notify
								}).then(vm => {

								})
							})
						}
					}
				})
			},
			toDetail(order_id, activeName = '2') {
                import('@/views/sale/order/pages/Detail').then(comp => {
                    this.$openSilde(comp, {
                        order_id,
                        activeName
                    }).then(vm => {
                        
                    })
                })
			},
			 /* 订单退货申请详情 */
            toRetuFnDetail(apply_id) {
                import("@/views/sale/refund/pages/Detail").then((comp) => {
                    this.$openSilde(comp, {
                        apply_id,
                    }).then((vm) => {});
                });
            },
			/* 企业审批 */
			toEnterpriseApproval(apply_id){
                import("@/views/user-manage/pages/business-management/components/detailCompanyDialog").then((comp) => {
                    this.$openSilde(comp, {
                        apply_id,
                    }).then((vm) => {});
                });
			},

			getAllAreaList() {
				let provinceData = []
				let cityData = []
				let areasData = {}
				this.$ajax("Admin/Location/getAllAreaList", {}, { method: 'GET' }).then(res => {
					res.data.list.forEach(item => {
						if (item.level == 1) {
							provinceData.push({ value: item.id, text: item.name })
						}
						if (item.level == 2) {
							let province = cityData.find(data => data.pid == item.upid)
							if (province) {
								province.city.push({ cid: item.id, name: item.name })
							} else {
								cityData.push({ pid: item.upid, city: [{ cid: item.id, name: item.name }] })
							}
						}
						if (item.level == 3) {
							let city = areasData[item.upid]
							if (city) {
								city.push({ areaid: item.id, name: item.name })
							} else {
								areasData[item.upid] = [{ areaid: item.id, name: item.name }]
							}
						}
					})
					localStorage.setItem('allAreaList', JSON.stringify({ provinceData, cityData, areasData }))
				});
			},
			handleToOrderDetail(row) {
				console.log(row)
				this.$router.push({
					path: row.url,
				})
				// setTimeout(() => {
					if(row.url) {
						const query_id = row.url.split("=")[1];
						switch (row.notify_type) {
							/* 销售 */
							case '0':
								this.toDetail(query_id, "1");
							break;
							/* 退货 */
							case '1':
								this.toRetuFnDetail(query_id);
							break;
							/* 企业审批 */
							case '2':
							    this.toEnterpriseApproval(query_id);
							break;
							/* 拣货单 */
							case '3':
						     	this.toDetail(query_id, "1");
							break;
						}
						// this.$eventBus.$emit('viewOrderDetail', row.url.split('=')[1])
					}
					if(row.is_read == 0) {
						this.handleSetRead(row.id)
					}
				// }, 500)
				
			},
			handleSetRead(id) {
				if(this.orderMessageList.length === 0) return
				this.$ajax("Admin/Notify/setRead", {id}, { method: 'GET' }).then(res => {
					if(res.status === 200) {
						if(id === 'all') {
							this.orderMessageList.forEach(_i => {
								_i.is_read = '1'
							})
							this.unread_count = 0
							this.$messageOrder._orderData.unread_count = 0
						} else {
							this.orderMessageList.forEach(_i => {
								if(_i.id == id) {
									_i.is_read = '1'
								}
							})
							this.$messageOrder._orderData.unread_count = this.$messageOrder._orderData.unread_count - 1
							this.unread_count = this.unread_count - 1
						}
					}
				})
			},
			handleClearMessage() {
				if(this.orderMessageList.length === 0) return
				this.$ajax("Admin/Notify/del", {id: 'all'}, { method: 'GET' }).then(res => {
					if(res.status === 200) {
						this.$messageOrder.page = 1
						this.$messageOrder._getOrderList({page: this.$messageOrder.page, limit: 50, reload: true})
					}
				})
			},
			getSettings() {
				this.$ajax("Admin/ShopSettings/getSettings", {}, { method: "POST" }).then(
					(res) => {
						if(res.status === 200) {
							const userInfo = JSON.parse(localStorage.getItem('userInfo'))
							localStorage.setItem('notify_voice_switch_' + userInfo.uid, res.data.notify_voice_switch)
						}
					}
				);
			},
			/* 消息语音提醒 */
			initMessageAduio(){
				const audioScope = new AudioScope(this.$refs.audio)
				this.$eventBus.$on('onNewMessageOrder', (res) => {
                    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
					const isNotifyVoice = localStorage.getItem('notify_voice_switch_' + userInfo.uid);
					if(this.$refs.audio && isNotifyVoice && res.length){
						audioScope.init(res)
					}
					this.$message({
						showClose: true,
						message: '您有新的订单! 查看右上角消息处理'
					});
			    })
			},
			filterTime(time) {
				let text = ''
				if(time.length < 13) time = new Date(time*1000)
				if(time.getMonth() == new Date().getMonth() && time.getDate() == new Date().getDate()) {
					text += '今天 '
				} else {
					text += (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) + "/" : (time.getMonth() + 1) + "/";
        	text += time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
				}
				text += " " + time.getHours() < 10 ? " " + '0' + time.getHours() + ":" : " " + time.getHours() + ":";
        text += time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
				return text
			},
			getqxbURL,
			myTime
		},
		mounted() {
			const _this = this
			this.getSettings()
			var user = localStorage.getItem('userInfo');
			if (user) {
				user = JSON.parse(user);
				this.sysUserName = user.name || '';
				this.sysShopName = user.shop_name
				this.sysUserAvatar = user.avatar || '';
				this.noticeHanlder()
			}
			document.addEventListener('visibilitychange', function () {
                if (document.visibilityState === 'visible') {
					let userInfo = JSON.parse(localStorage.getItem('userInfo'));
					if (_this.sysUserName != userInfo.name) {
						_this.$router.go(0)
					}
                }
			});
			window.addEventListener("message", (event) => {
                var data = event.data;
                //console.log(data)
                switch (data.cmd) {
                    case 'stock-billing-close-to-order-detail':
						// this.toDetail(data.params.order_id)
                        setTimeout(() => {
							import('@/views/sale/order/pages/DetailCopy').then(comp => {
								this.$openSilde(comp, {
									order_id:data.params.order_id,
									activeName:'2'
								})
							})
                        }, 1000)
                    break;
                }
			});
			this.$eventBus.$on('ccj-notice-switch', () => {
				this.getMerchantPeek()
			})
			this.$nextTick(() =>{
				this.initMessageAduio()
			})
			// this.$eventBus.$on('onNewMessageOrder', async (res) => {
			// 		const userInfo = JSON.parse(localStorage.getItem('userInfo'))
			// 		const audioUrlMap = {
			// 			'0':'/message_order_tips.mp3',
			// 			'1':'/return_groods_tips.mp3',
			// 			'2':'/enterprise_approval_tips.mp3',
			// 			'3':'/picking_order_tips.mp3'
			// 		}
			// 		if(res.length && res[0]['notify_type']){
			// 			this.audioUrl = `${this.getStaticUrl}${audioUrlMap[res[0]['notify_type']]}`;
			// 		}else{
			// 			this.audioUrl = ''
			// 		}
			// 		console.log(res, '语音提醒')
			// 		if(this.$refs.audio && localStorage.getItem('notify_voice_switch_' + userInfo.uid) == 1 && this.audioUrl) {
			// 			    await this.$nextTick()
			// 				this.$refs.audio.play().then(res => {
			// 					console.log('正常播放语音')
			// 				}).catch(error => {
			// 					console.log('需要用户有交互才有语音提示哦')
			// 				})
			// 		}
			// 		this.$message({
			// 			showClose: true,
			// 			message: '您有新的订单! 查看右上角消息处理'
			// 		});
					
			// })
			this.$eventBus.$on('onMessageOrderList', res => {
					console.log(res)
					this.loading = false
					this.orderMessageList = res.list;
					this.unread_count = res.unread_count
			})
			this.$nextTick(() => {
				const bodyElement = document.getElementById('message-box')
				bodyElement.onscroll = (event) => {
					const target = event.target
						if (target.scrollTop + target.clientHeight >= target.scrollHeight - 50) {
								if (!this.loading && !this.$messageOrder._isNoMore) {
										this.loading = true
										this.$messageOrder._page = this.$messageOrder._page + 1
										this.$messageOrder._getOrderList({page: this.$messageOrder._page, limit: 50})
								}
						}
				}
			})
			
		},
		beforeDestroy () {
				this.$eventBus.$off('onNewMessageOrder')
				this.$eventBus.$off('onMessageOrderList')
				this.$eventBus.$off('ccj-notice-switch')
		}
	}
</script>




// WEBPACK FOOTER //
// Home.vue?ff8db540